import { UIText2 } from '@cian/ui-kit';

import { type ReactNode } from 'react';

import styles from './Thumbnails.css';

type Thumbnail = {
  id: number;
  src: string;
  overlay?: {
    text: string;
  };
};

type ThumbnailsProps = {
  thumbnails: Thumbnail[];
  hasMore?: boolean;
};

export function Thumbnails({ thumbnails, hasMore }: ThumbnailsProps): ReactNode {
  return (
    <div className={styles['thumbnails']}>
      {thumbnails.map((thumbnail, index) => (
        <div
          className={styles['thumbnail']}
          data-testid={`card-gallery.thumbnail-${index + 1}`}
          key={`thumbnail-${thumbnail.id}`}
        >
          <img decoding="async" loading="lazy" src={thumbnail.src} />
          {hasMore && index === thumbnails.length - 1 && (
            <div className={styles['overlay']}>
              <UIText2 color="text-inverted-default">Ещё фото</UIText2>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
